import React, { useRef } from 'react'
import { useEffect, useState } from 'react'

import { history } from 'lib/utils/navigation'
import { DASHBOARD_ROUTE } from 'domains/application/navigation/routes'
import AppLoadingScreen from 'domains/application/screens/AppLoadingScreen'
import { useAuth0 } from '@auth0/auth0-react'
import { setAccessToken } from 'lib/api/utils'
import { auth0Login, LoginError } from '../hooks/useAutoAuth0Login'
import { useLogout } from '../hooks/useLogout'
import GenericError from 'domains/application/components/GenericError'
import PendingApproval from 'domains/application/components/PendingApproval'

function OAuth2RedirectScreen() {
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect } =
    useAuth0()
  const logout = useLogout()

  const initiated = useRef(false)

  const [error, setError] = useState<LoginError>()

  const getReturnToPath = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const returnTo = searchParams.get('returnTo')
    if (returnTo) {
      try {
        return decodeURIComponent(returnTo)
      } catch {
        return DASHBOARD_ROUTE
      }
    }
    return DASHBOARD_ROUTE
  }

  useEffect(() => {
    if (initiated.current) return

    initiated.current = true

    const getToken = async () => {
      try {
        const token = await getAccessTokenSilently()
        setAccessToken(token)

        const loginResponse = await auth0Login()
        if (!loginResponse?.success) {
          if (loginResponse?.error) {
            setError(loginResponse.error)
            return
          }
          logout()
          return
        }

        history.replace(getReturnToPath())
      } catch (err: Error | any) {
        if (err.message === 'switchboard_login_fail') {
          logout()
          return
        }
        loginWithRedirect()
      }
    }

    getToken()
  }, [getAccessTokenSilently, isAuthenticated, loginWithRedirect, logout])

  if (error) {
    if (error.errorCode === 'INVALID_CRM_CONTACT') {
      return <PendingApproval onGoBack={logout} />
    }
    return (
      <GenericError
        title="Login Failed"
        subtitle={error.message}
        onGoBack={logout}
      />
    )
  }

  return <AppLoadingScreen />
}

export default OAuth2RedirectScreen
